import React from 'react';

import { CoreLink } from '@uncinc/react-drupal-core';
import { Container, Image } from '@uncinc/uncinc-react-kitchen-sink';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
} from '../../../config/constants';

import './style.scss';


const ParagraphCtaCampaign = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const linkUrl = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title'], '');
  const image = entity.getIn(['field_image', 0, 'styles'], null);
  const imageAltText = entity.getIn(['field_image', 0, 'alt'], '');

  return (
    <Container className="ParagraphCtaCampaign">
      {/* main cta paragraph content */}
      <div className="row">
        <div className="ParagraphCtaCampaign__column col-12">
          <div className="ParagraphCtaCampaign__wrapper">
            <h2 className="asH1">{title}</h2>
            <div className="ParagraphCtaCampaign__image">
              <div className="ParagraphCtaCampaign__image--overlay" />
              <Image
                lazyload
                includeWebP
                alt={imageAltText}
                src={{
                  [SCREEN_MOBILE]: image.getIn(['crop_3_4']),
                  [SCREEN_TABLET]: image.getIn(['crop_4_3']),
                  [SCREEN_NORMAL]: image.getIn(['crop_4_3']),
                }}
              />
            </div>
            <div className="ParagraphCtaCampaign__cta__wrapper">
              <CoreLink
                to={linkUrl}
                className="ParagraphCtaCampaign__link"
              >
                {linkTitle}
                <i className="icon icon-arrow-right-filled icon-variant-4" />
              </CoreLink>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphCtaCampaign;
